export const SEARCH_PARAMS = {
    QUERY: 'q',
    PROJECT_ID: 'project_id',
    AGENT_ID: 'agent_id',
    FLOW_ID: 'flow_id'
} as const;

export type SearchParamKey = (typeof SEARCH_PARAMS)[keyof typeof SEARCH_PARAMS];
